module.exports = __webpack_public_path__ + "assets/icons_helipad-pin--public.420f3c5c.svg";